import React from "react";
import { Spin } from "antd";
import PropTypes from "prop-types";
import { LoadingOutlined } from "@ant-design/icons";

const Icon = <LoadingOutlined style={{ fontSize: 35 }} spin />;

const Loading = (props) => {
  const { align = "center", cover = "content" } = props;
  let coverContent = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate('-50%','-50%')",
  };
  let converPage = {
    position: "fixed",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div
      className={`loading text-${align} `}
      style={cover === "content" ? converPage : coverContent}
    >
      <Spin indicator={Icon} />
    </div>
  );
};

Loading.propTypes = {
  size: PropTypes.string,
  cover: PropTypes.string,
};

export default Loading;
